import { ProductCard } from '@dfh-corp-sites/ui'
import React, { FC } from 'react'

import useRetailPrices from '../../../../../hooks/useRetailPrices'
import { useTestKitPrice } from '../../../../../hooks/useTestKitPrice'
import { ParentProductSelectionForModal } from '../../../../../lib/products/modal/types'
import { openQuickViewProductModal } from '../../../../../lib/products/quick-view-modal'
import { IndexedProduct } from '../../../../../lib/products/types'
import useSanityImage from '../../../../../lib/sanity/hooks/useSanityImage'
import { formatAsCurrency } from '../../../../../utils/priceTools'
import Link from '../../../../global/Link'

import productImagePlaceholder from '../../../../../img/product-image-placeholder.png'

export interface ProductBannerCardProps {
  className?: string
  product: IndexedProduct
  productDetails?: ParentProductSelectionForModal
  analyticsEventAppContext?:
    | 'plp'
    | 'related_products'
    | 'featured_products'
    | 'dispensary_featured_products'
}

const ProductBannerCard: FC<ProductBannerCardProps> = ({
  // className,
  product,
  productDetails,
  analyticsEventAppContext,
}) => {
  const { shouldDisplayRetailPrice } = useRetailPrices()
  const sanityImageUrl = useSanityImage(
    { sourceJson: product.sanityImageJson || undefined },
    {
      dpr: 2,
      fit: 'max',
      // set width only to avoid crop bug: https://github.com/sanity-io/image-url/issues/32
      width: 175,
    },
  )
  const productUrl = sanityImageUrl || productImagePlaceholder

  const productPrice =
    product.priceRange?.minimum &&
    formatAsCurrency({ amount: parseFloat(product.priceRange?.minimum) })
  const productRetailPrice =
    product.retailPriceRange?.minimum &&
    shouldDisplayRetailPrice &&
    formatAsCurrency({ amount: parseFloat(product.retailPriceRange?.minimum) })

  const { shouldShowTestKitPrice } = useTestKitPrice()

  return (
    <ProductCard
      price={productPrice}
      retailPrice={productRetailPrice || undefined}
      image={{
        src: productUrl,
        alt: product.name || undefined,
      }}
      title={<Link to={`/products/${product.urlKey}/`}>{product.name}</Link>}
      onAddToCart={() => {
        openQuickViewProductModal({
          sku: product.sku,
          urlKey: product.urlKey,
          productDetails,
          analyticsEventAppContext,
        })
      }}
      showPrice={shouldShowTestKitPrice(product.sku)}
    />
  )
}

export default ProductBannerCard
